type LogOptions = {
  level: 'debug' | 'info' | 'warning' | 'error' | 'fatal';
};

const getLogger = () =>
  window.Sentry || {
    captureMessage(message: Error | string, options: LogOptions) {
      // eslint-disable-next-line no-console
      console.log(`[SentryMock] ${message}`, options);
    },
  };

export const log = (error: Error | string, options: LogOptions) => {
  getLogger().captureMessage(error, options);
};

export const logError = (error: Error | string, options: LogOptions = { level: 'error' }) => {
  log(error, options);
};
